<!-- Contact Start -->
<div class="contact-wrapper">
    <div class="ct-contact-map-wrapper">
        <div class="ct-contact-map" leaflet [leafletOptions]="options" (leafletMapReady)="onMapReady($event)"></div>
        <a href="https://maps.google.com/?q=51.5,-0.09" target="_blank" class="btn-custom shadow-none">Voir sur google maps</a>
    </div>
    <div class="">
        <div class="section section-padding">
            <div class="container">
                <div class="contact-info">
                    <div class="row">
                        <div class="col-xl-6">
                            <div class="ct-info-box">
                                <i class="flaticon-location"></i>
                                <h5>Notre Adresse</h5>
                                <span>5629 Rue Saint-Georges</span>
                                <span>Lévis, QC G6V 4M1, Canada</span>
                                <span> +1 418-576-7676 </span>
                            </div>
                        </div>
                        <div class="col-xl-6">
                            <div class="ct-info-box">
                                <i class="flaticon-online-booking"></i>
                                <h5>Heures d'ouverture</h5>
                                <span><span>Lundi - Jeudi:</span> 11h00 à 19h00</span>
                                <span><span>Vendredi - Samedi:</span> 11h00 à 20h00</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section pt-0">
            <div class="container">
                <div class="section-title-wrap">
                    <h2 class="title">Envoyez-nous un Message</h2>
                </div>
                <form method="post">
                    <div class="row">
                        <div class="form-group col-lg-6">
                            <input type="text" placeholder="Prénom" class="form-control" name="fname">
                        </div>
                        <div class="form-group col-lg-6">
                            <input type="text" placeholder="Nom" class="form-control" name="lname">
                        </div>
                        <div class="form-group col-lg-12">
                            <input type="email" placeholder="Adresse Email" class="form-control" name="email">
                        </div>
                        <div class="form-group col-lg-12">
                            <input type="text" placeholder="Sujet" class="form-control" name="subject">
                        </div>
                        <div class="form-group col-lg-12">
                            <textarea name="message" class="form-control" placeholder="Ecrivez votre message ici" rows="8"></textarea>
                        </div>
                    </div>
                    <button type="submit" class="btn-custom primary" name="button">Enovoyer le message</button>
                </form>
            </div>
        </div>
    </div>
</div>
<!-- Contact End -->